import DomainSidebar from '../../components/domain/DomainSidebar';
import GlobalSidebar from '../../components/domain/GlobalSidebar';
import { DomainKey } from '../../config/domains';
import { useDomainAccess } from '../../hooks/useDomainAccess';

interface MainSidebarProps {
  domainKey?: DomainKey;
  collapsed?: boolean;
  onToggle?: () => void;
}

/**
 * MainSidebar Component
 * Shows either:
 * - GlobalSidebar: Global navigation menu (App/User/Admin sections) when no domainKey
 * - DomainSidebar: Domain-specific navigation when domainKey is provided
 */
export default function MainSidebar({ domainKey }: MainSidebarProps) {
  const { canAccessDomain } = useDomainAccess();

  // If no domainKey provided, show global sidebar
  if (!domainKey) {
    return <GlobalSidebar />;
  }

  // If user doesn't have access to the domain, don't render sidebar
  if (!canAccessDomain(domainKey)) {
    return null;
  }

  // Show domain-specific sidebar
  return <DomainSidebar domainKey={domainKey} />;
}
